import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import Forms from '@/components/forms/Forms'
import Tables from '@/components/forms/Tables'
import TableColumn from '@/components/forms/TableColumn'
import { loading } from '@/shared/utils/UIHelper'
import MechanicalWorkshop from '@/views/private/configuration/mechanicalworkshop/mechanicalworkshop.vue'

import MechanicalWorkshopRepository from '@/shared/http/repositories/configuration/mechanicalworkshop'
import MechanicalWorkshopModal from '@/components/mechanicalworkshop/mechanicalworkshop.vue'
import SinisterMechanicalWorkshopData from './model/sinistermechanicalworkshopmodel.js'
import SinisterMechanicalWorkshopForm from './form/sinistermechanicalworkshop-form'

import { debounce } from 'lodash'

export default {
  name: 'SinisterMechanicalWorkshop',
  mixins: [ActionsForm],
  data () {
    return {
      data: SinisterMechanicalWorkshopData,
      form: SinisterMechanicalWorkshopForm,
      showTable: false,
      objList: null,
      listMachineWorkshop: [],
      machineWorkshopSearch: '',
      selecteMachineWorkshop: null,
      objProp: {}
    }
  },
  components: {
    Forms,
    Tables,
    TableColumn,
    MechanicalWorkshop,
    MechanicalWorkshopModal
  },
  watch: {
    machineWorkshopSearch: debounce(function (data) {
      if (!data || data.trim().length < 3) {
        return
      }

      this.onSearch(data)
    }, 500),
    selecteMachineWorkshop: function (data) {
      // this.onEdit(data.value)
      this.onEditById(data.value.id)
    }
  },
  methods: {
    onClosedTable () {
      this.showTable = false
    },
    onLoad () {
      // --> Set manual
      this.$refs.machineWorkshopTypeahead.inputValue = ''
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      // --> Set manual
      this.$refs.machineWorkshopTypeahead.inputValue = ''
      this.machineWorkshopSearch = ''
    },
    onEdit (obj) {
      Tools.SetValueInForm(this.form, this.data, obj)
      // --> Set manual
      this.$refs.machineWorkshopTypeahead.inputValue = obj.name
      this.$emit('Edit', obj)
    },
    onEditById (ID) {
      this.objProp = {}
      if (ID && ID !== '00000000-0000-0000-0000-000000000000') {
        MechanicalWorkshopRepository.GetById(ID)
          .then((response) => {
            var obj = this.onResultObj(response)
            if (obj !== null) {
              this.onEdit(obj)
              this.objProp = response.data.data
            }
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        this.$emit('Edit', null)
      }
    },
    onSearch (value) {
      loading.push()
      if (value) {
        MechanicalWorkshopRepository.GetAllByName(value)
          .then((response) => {
            this.listMachineWorkshop = this.onResultAutoComplete(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        this.onClear()
        this.$emit('Edit', null)
        loading.pop()
      }
    },
    showModal () {
      this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/regulation/auto/mechanicalworkshop/sinistermechanicalworkshop.js